import ActionConfirmationModal from './ActionConfirmationModal';

const DeleteConfirmationModal = ({ 
  show, 
  onClose, 
  onConfirm, 
  title = "Silme Onayı",
  message, 
  itemName,
  warningMessage,
  consequences = [],
  loading = false,
  type = "default", // "default", "warning", "danger"
  isArchive = false // true for archive operations, false for delete operations
}) => {
  const defaultMessage = message || (itemName ? 
    `"${itemName}" öğesini silmek istediğinizden emin misiniz?` : 
    "Bu öğeyi silmek istediğinizden emin misiniz?"
  );

  return (
    <ActionConfirmationModal
      show={show}
      onClose={onClose}
      onConfirm={onConfirm}
      title={title}
      message={defaultMessage}
      details={warningMessage}
      consequences={consequences}
      loading={loading}
      tone={isArchive ? 'warning' : type === 'danger' ? 'danger' : 'warning'}
      confirmLabel={
        isArchive
          ? (loading ? 'Arşivleniyor...' : 'Arşivle')
          : (loading ? 'Siliniyor...' : 'Sil')
      }
      cancelLabel="İptal"
    />
  );
};

export default DeleteConfirmationModal;
